import { BaseApiService } from "@mirage/services/BaseApiService";
import { IPlanningAppealsFilteringLists } from "@shared/publicportal/contracts/PlanningAppealsFilteringLists";
import { IEntityPageResult } from "@shared/mirage/core/contracts/IEntityPageResult";
import { IPlanningAppealDetails } from "@shared/publicportal/contracts/IPlanningAppealDetails";
import { IEntityPageRequest } from "@shared/mirage/core/contracts/IEntityPageRequest";
import { IPAppeal } from "@shared/publicportal/entities/IPAppeal";
import { IPlanningAppealsService } from "@shared/publicportal/services/IPlanningAppealsService";

export default class PlanningAppealsService extends BaseApiService implements IPlanningAppealsService {
    constructor() {
        super("publicportal/planningAppeals");
    }

    async getPlanningAppeals(): Promise<any> {
        const response = await this.httpInstance().get("/");
        return response.data;
    }

    async getFilteringLists(): Promise<IPlanningAppealsFilteringLists> {
        const existingFilters = sessionStorage.getItem("publicportal.PlanningAppealsService.dictionaries");
        if (!existingFilters) {
            const response = await this.httpInstance().get("/filters");
            const filters = response.data;
            sessionStorage.setItem("publicportal.PlanningAppealsService.dictionaries", JSON.stringify(filters));
            return filters;
        }
        return JSON.parse(existingFilters);
    }
    async pageRequest(pr: IEntityPageRequest): Promise<IEntityPageResult<IPAppeal>> {
        const response = await this.httpInstance().post("/pageRequest", pr);
        return response.data;
    }

    async getPlanningAppealById(planningAppealId: number): Promise<IPlanningAppealDetails> {
        const response = await this.httpInstance().get(`/${planningAppealId}`);
        return response.data;
    }
}
